import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { EyeOff } from 'lucide-react';

/**
 * BlurredValue Component
 * Displays blurred values for demo users when blur_sensitive_figures is enabled
 * 
 * @param {string|number} value - The value to display (formatted)
 * @param {string} className - Additional CSS classes
 * @param {boolean} alwaysShow - If true, never blur (for non-sensitive data)
 */
const BlurredValue = ({ value, className = '', alwaysShow = false }) => {
  const { user } = useAuth();
  
  // Check if we should blur this value
  const shouldBlur = !alwaysShow && user?.is_demo && user?.blur_sensitive_figures;
  
  if (shouldBlur) {
    return (
      <span 
        className={`inline-flex items-center gap-1 ${className}`}
        title="Value hidden in demo mode"
      >
        <span className="blur-sm select-none">{value}</span>
        <EyeOff className="w-3 h-3 text-gray-400 flex-shrink-0" />
      </span>
    );
  }
  
  return <span className={className}>{value}</span>;
};

export default BlurredValue;
